import moment from "moment";
const DEFAULT_DAY_FORMAT_DOT = "DD.MM.YYYY";
const DEFAULT_DAY_FORMAT_SLASHES = "DD/MM/YYYY";
const DEFAULT_DAY_AND_TIME_FORMAT_DOT = "DD.MM.YYYY HH:mm";
const DEFAULT_DAY_AND_TIME_FORMAT_SLASHES = "DD/MM/YYYY HH:mm";

// 'label:label:label:value' => 'value'
export function getValueFromStr(stringValue) {
    if (!stringValue) return null;
    const arrayValue = stringValue.split(":");
    return arrayValue.slice(arrayValue.length - 1)[0]; // get last value
}

// export function getDefaultValuesFromWidgets(widgets) {
//     const defaultValues = widgets.reduce((prev, curr) => {
//         if (curr.widgetType === "customComponent") {
//             return prev;
//         }
//         return {
//             ...prev,
//             [curr.key]: curr.defaultValue,
//         };
//     }, {});
//     return defaultValues;
// }

// probably only TTWOS specific array to omit the check
// TTWOS could send to us a date or datetime widgets with values array provided (to handle default value logic)
// we should omit the check if existing value exists in the list of the values in such case
const WIDGETS_WITHOUT_VALUE_IN_VALUES_CHECK = ["date", "datetime"];


// set initialValues in redux form in format { key: value }
export function getInitialValuesFromWidgets(widgets, isOnceInitialized, withAjaxAndFilesExValue) {
    const initialValues = widgets.reduce((prev, curr) => {
        // do not initialize for a customComponent
        if (curr.widgetType === "customComponent") {
            return prev;
        }

        // for multiselect always return 'savedValus' new field
        if (curr.widgetType === "multiselect") {
            return {
                ...prev,
                [curr.key]: curr.savedValues,
            };
        }
        // we need to init ajaxCombo and files with ex values (key, value, label) for Appeal Knowledgebase template set to properly fill the form
        if (withAjaxAndFilesExValue) {
            if (curr.values && Array.isArray(curr.values)) {
                if (curr.widgetType === "ajaxCombo") {
                    const ajaxValue = isOnceInitialized ? curr.savedValue : curr.savedValue || curr.defaultValue;
                    const fullValue = curr.values.find(item => item.key === ajaxValue);
                    if (fullValue) {
                        const value = { key: ajaxValue, value: ajaxValue, label: fullValue.value };
                        return {
                            ...prev,
                            [curr.key]: value,
                        };
                    }
                }
                if (["fileMultiple", "fileSingle"].includes(curr.widgetType)) {
                    const fileValue = curr.savedValues;
                    if (Array.isArray(fileValue)) {
                        const fileValues = curr.values.filter(item => fileValue.includes(item.key)).map(({key, value}) => ({key, value}));
                        return {
                            ...prev,
                            [curr.key]: fileValues,
                        };
                    }
                }
            }
        }

        // for files always return 'savedValues' new field in case it is not an empty fiels
        // could be probably combined with the logic upper for "multiselect"
        if (Array.isArray(curr.savedValues) && curr.savedValues.length > 0 && curr.widgetType.startsWith("file")) {
            return {
                ...prev,
                [curr.key]: curr.savedValues,
            };
        }

        // handle value init for the rest of the widgets
        let value = isOnceInitialized ? curr.savedValue : curr.savedValue || curr.defaultValue;
        // clear up value if there no such value is available in curr.values (select options)
        if (
            curr.values &&
            Array.isArray(curr.values) &&
            curr.values.length > 0
        ) {
            // we should omit value clear up in WIDGETS_WITHOUT_VALUE_IN_VALUES_CHECK
            if (value && !WIDGETS_WITHOUT_VALUE_IN_VALUES_CHECK.includes(curr.widgetType)) {
                // check values with an object format
                if (curr.hasExValue && value && typeof value === 'object') {
                    const isValueInValues = curr.values.find(val => val.key === value.value);
                    // console.log({values: curr.values, value, isValueInValues});
                    if (!isValueInValues) {
                        value = null;
                    }
                // handle case when saved value is hasExValue, but it was saved as a plain value, for example value: "8000000000"
                // we need to find an object in values and set the initial value in object format: { label, value }
                } else if (curr.hasExValue && value) {
                    const valueInValues = curr.values.find(val => val.key === value); // example of saved hasExValue: { label:"🔴 м. Київ /Київ", value:"8000000000" }
                    if (valueInValues && typeof valueInValues === "object") {
                        value = {
                            label: valueInValues.label || valueInValues.value,
                            value: valueInValues.key || valueInValues.value,
                        };
                    } else {
                        value = null;

                    }
                } else {
                    const isValueInValues = curr.values.find(val => val.key === value);
                    // console.log({values: curr.values, value, isValueInValues});
                    if (!isValueInValues) {
                        value = null;
                    }
                }
            }

            // probably only TTWOS specific logic
            // specific case for the widgets with the "default" param available
            // if there is no value saved and only 1 default value is available - we need to set this value as selected.
            // if (!(curr.savedValue || curr.defaultValue)) {
            if (!value) {
                // console.log({curr});
                const defaultValues = curr.values.filter(val => val.default);
                if (Array.isArray(defaultValues) && defaultValues.length === 1) {
                    const defaultValue = defaultValues[0];
                    if ('key' in defaultValue) {
                        value = defaultValue.key;
                        // extra check for date widgets
                        if (curr.widgetType === "date") {
                            const trimmedVal = value.trim().slice(0, DEFAULT_DAY_FORMAT_DOT.length);  // we need to trimm for the safety, since it could be a date with time and it will not be valid 
                            const isValidDot = moment(trimmedVal, DEFAULT_DAY_FORMAT_DOT, true).isValid();
                            const isValidSlashes = moment(trimmedVal, DEFAULT_DAY_FORMAT_SLASHES, true).isValid();
                            if (isValidDot || isValidSlashes) {
                                const finalMask = isValidDot ? DEFAULT_DAY_FORMAT_DOT : DEFAULT_DAY_AND_TIME_FORMAT_SLASHES;
                                // convert date to timestamp
                                const ts = moment(trimmedVal, finalMask).valueOf();
                                value = ts;
                            }
                        }
                        if (curr.widgetType === "datetime") {
                            const isValidDot = moment(value, DEFAULT_DAY_AND_TIME_FORMAT_DOT, true).isValid();
                            const isValidSlashes = moment(value, DEFAULT_DAY_AND_TIME_FORMAT_SLASHES, true).isValid();

                            if (isValidDot || isValidSlashes) {
                                const finalMask = isValidDot ? DEFAULT_DAY_FORMAT_DOT : DEFAULT_DAY_AND_TIME_FORMAT_SLASHES;
                                // convert date to timestamp
                                const ts = moment(value, finalMask).valueOf();
                                value = ts;
                            }
                        }
                    }
                }
            }
        }
        // do not initialise a savedValue in the refKey widget, if refKey value is not available in values (options of select for example)
        if (curr.refKey && curr.values && Array.isArray(curr.values) && curr.values.length > 0) {
            const refWidget = widgets.find(widget => widget.key === curr.refKey);
            if (refWidget) {
                const refValue = refWidget.savedValue || refWidget.defaultValue;
                if (![null, undefined, ""].includes(refValue)) {
                    const refOptions = curr.values.filter(val => {
                        // added additional check for refVal options to be an array
                        if (val.refVal && Array.isArray(val.refVal)) {
                            return val.refVal.includes(refValue);
                        }
                        // othervise return value
                        return val;
                    });
                    const isValueExist = refOptions.find(option => option.key === value);
                    if (!isValueExist) {
                        value = null;
                    }
                }
            }
        }

        return {
            ...prev,
            [curr.key]: curr.rule === "#[callMethod]" ? getValueFromStr(value) : value,
        };
    }, {});

    return initialValues;
}
